// Admin console Firebase init — SAME `danvantri` project + Firestore as the
// patient app (shared database, per your requirement). Auth is Google sign-in;
// the console is gated to ADMIN_EMAIL client-side AND (once deployed) by
// firestore.rules `isAdmin()`. The config values are public by design.
import { initializeApp } from 'firebase/app';
import {
  getAuth, GoogleAuthProvider, signInWithPopup, signOut,
  onAuthStateChanged, setPersistence, browserLocalPersistence, type User,
} from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { writable } from 'svelte/store';

export const firebaseConfig = {
  apiKey: 'AIzaSyBMZTCNDQ_q-Vu_GerG8RmnZ2OC9KHWYF4',
  authDomain: 'health.dreamgiga.ai',
  projectId: 'danvantri',
  storageBucket: 'danvantri.firebasestorage.app',
  messagingSenderId: '1049536826524',
  appId: '1:1049536826524:web:8f0b582731fb18eb357159',
};

// Admin allowlist. To hand off to admin@dreamgiga.ai later, add it here AND in
// functions/admin.mjs (ADMIN_EMAIL) + firestore.rules (isAdmin) — the server + rules
// are the real gate; this client check is UX. Keeping it a list makes that a 1-line edit.
export const ADMIN_EMAILS = ['vishnu@dreamgiga.ai'];
export const ADMIN_EMAIL = ADMIN_EMAILS[0];   // shown on the login screen

export const fbApp = initializeApp(firebaseConfig);
export const fbAuth = getAuth(fbApp);
export const fbDb = initializeFirestore(fbApp, { ignoreUndefinedProperties: true });
export const fbStorage = getStorage(fbApp);

const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });
setPersistence(fbAuth, browserLocalPersistence).catch(() => {});

export const authUser = writable<User | null>(fbAuth.currentUser);
onAuthStateChanged(fbAuth, (u) => authUser.set(u));

export const signInWithGoogle = () => signInWithPopup(fbAuth, provider);
export const signOutUser = () => signOut(fbAuth);
export const isAdminEmail = (email?: string | null) =>
  ADMIN_EMAILS.includes((email ?? '').trim().toLowerCase());
